import React, { useContext, useEffect } from "react";
import { getSortedProductGroups, initialProductGroupFilter } from "./FilterTypes/ProductGroupFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiProductGroupList from "components/Picker/ProductGroupPicker/MultiProductGroupList";

const ProductGroupFilter = () => {
  const title = RESX.ProductGroup.resxProductGroup;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("productGroup", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedProductGroups(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedProductGroups.length > 0,
    reset: () => initialProductGroupFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedProductGroups.map(c => c.productGroupId), b.selectedProductGroups.map(c => c.productGroupId))
  });
  useEffect(() => {
    setInitialValue("productGroup", initialProductGroupFilter);
  }, []);

  const [selectedProductGroups, setSelectedProductGroups] = React.useState<server.dto.ProductGroup[]>(initialProductGroupFilter.selectedProductGroups);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedProductGroups(getValue("productGroup").selectedProductGroups);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("productGroup", {
      selectedProductGroups
    });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.hasProductGroups) return <></>;

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiProductGroupList
        value={selectedProductGroups}
        onChange={setSelectedProductGroups}

      />
    </MultiPickerFilterPopup>
  </div>;
};

export default ProductGroupFilter;
